const sendMessage = (isSuccess: boolean) => {
  const msg = {
    service: 'LimepayIdentity',
    isSuccess,
  };
  window.parent.postMessage(JSON.stringify(msg), '*');
};

export default sendMessage;
